export const TIPOS_DATO = {
  NUMERICO: 'numerico',
  BOOLEANO: 'booleano',
  SELECCION: 'seleccion',
  //RANGO: 'rango',          // Para escalas (1-5, leve-moderado-grave)
  TEXTO: 'texto',          // Para notas o descripciones
  FECHA: 'fecha',          // Para inicio de síntomas
  DURACION: 'duracion',    // Para duración de síntomas (horas/días)
  MULTIPLE: 'multiple',    // Selección múltiple de opciones
  //ESCALA: 'escala',        // Escala numérica (ej: dolor 0-10)
  COMPUESTO: 'compuesto'   // Para campos con múltiples lecturas/valores relacionados
};
